import React from "react";

import { Album, Track, Artist } from "@music/models";
import { Bundle } from "@upload/models";
import { NotFoundPage } from "../pages/not-found-page";

export interface HasAlbum {
    album: Album;
}

export interface HasTrack {
    track: Track;
}

export interface HasArtist {
    artist: Artist;
}

export interface HasBundle {
    bundle: Bundle;
}

export const makeNotFound = <P extends {}>(prop: keyof P) => (
    WrappedComponent: (React.ComponentClass<P>
        | React.StatelessComponent<P>),
) => {
    return (props: P) => {
        if (props[prop] == null) {
            return <NotFoundPage />;
        }
        else {
            return <WrappedComponent {...props} />;
        }
    };
};

export const albumNotFound = makeNotFound<HasAlbum>("album");
export const trackNotFound = makeNotFound<HasTrack>("track");
export const artistNotFound = makeNotFound<HasArtist>("artist");
export const bundleNotFound = makeNotFound<HasBundle>("bundle");
